<template>
  <div class="dlrToast" :layerName="layerName" :visible="visible">
    <div class="dlrToast-card">
      <p class="dlrToast-card-icons">
        <!--iconLoading 加载中-->
        <!--iconUpload 正在上传-->
        <!--iconOk 发送成功-->
        <!--iconError 发送失败-->
        <!--iconSigh 警告文案-->
        <i class="dlrToast-icon" :class="iconCls"></i>
      </p>
      <p class="dlrToast-card-text">{{ message }}</p>
    </div>
    <div v-show="hasMask" class="dlrToast-bg"></div>
  </div>
</template>
<script>
import * as layerNames from '../services/layerName';
export default {
  props: {
    iconCls: {
      type: String,
      default: 'fn-hide'
    },
    message: {
      type: String,
      default: ''
    },
    hasMask: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      layerName: layerNames.TOAST,
      visible: true,
    };
  }
};
</script>
<style lang="scss">
//==========
//loading动画定义
@keyframes dlrLoading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(365deg);
  }
}
//toast 层
.dlrToast {
  position: relative;
  z-index: 1010;
  // width: 200%;
  // height: 100%;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  &-icon {
    display: inline-block;
    margin: ptrd(12) 0 0 0;
    width: ptrd(64);
    height: ptrd(64);
    &.iconLoading {
      background: url("data:image/png;base64,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")
        no-repeat center center transparent;
      background-size: ptrd(64);
      animation: dlrLoading 1s infinite linear;
    }
    &.iconOk {
      border-radius: 50%;
      background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAC30lEQVR4Xu1YTahOURRdyz95KS/Pz0BkoMzEQM8YMwyNKANJMVAGTJgoA6VIegMTRm/GkExlgkyUEUpIeJFXPGJp67z67K7X/c693/3Odc8Z3nv22Xuts/Y+52yi44Mdx49MQFZAxxnIKdBxAeQimFMgp0DHGcgp0HEB5FMgp0BOgY4zkFOg4wLIp0BrU0DSIgBvAfwCsIbkzxg1t5KAAH6mB/AUydFOECBpPoAfwF/p+4Hkqv+egAD+O4B5Duxikva979GqFJBkIBc6lCMkp/tGHgxaQ4CkrwCWOKBjJN/Hgje7VhAg6ROAFQ7oRpIvq4BvBQGS3gBY64BuJ/moKvjkCZD0DMBmB3QXyXt1gE+aAEn3AYw7oAdITtYFvjIBko5bHSF5uc6gJN0GsNeteZLkpTr9VCLA7dA3kkvrCE7SBIAjbq2LJE/Vsb5fI/oUKDiTo6+js0FJOgfgrAvyJsmDgwBfVQEbALxwgb0iuT4mWElHAVxztndJ7olZr6xNtALMgaTdAO44Z09Ibi0bQFhnH4BbzuYxyW39rBMztxIBIfjDAK7H7pwkq/RW8XvHc5KbYgD1a1OZgEDCGQDnnfMbJA/NFZCkLQCeujnRL7t+wVeqAd6ZpKsAjrnvF0ieLgpM0joAr92/aZIjMUBibWpRwKxzSZbHls+94wTJK70fJK0E8NHNmyHpHzuxuErb1UpASIcHAHa4CPaTtMuNFc7lAL64/9bOsjd9VFurNNqCibUTEEAW3eF3AngIoLeV9We6vfGHAb7WGlBQE94BGCuxOwuGBX6gBAQlmNRN8v8a0a2sEsSWmjKQFHAFzyRvLWw/lpG0Ls9QRxMEWBfXNzJHSU4NFXlwPnACQioYCXbhsffDapKfUwA/8BqQCsi54mhEASkTkQlIeXeaiC0roAmWU/aRFZDy7jQRW1ZAEyyn7CMrIOXdaSK2rIAmWE7ZR1ZAyrvTRGxZAU2wnLKP3x7xuEFupVQkAAAAAElFTkSuQmCC")
        no-repeat center center rgba(#fff, 0.15);
      background-size: ptrd(64);
    }

    &.iconError {
      border-radius: 50%;
      background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABsklEQVR4Xu2ZwUrGQAyEk7OCXhTB9380QfSioOfIwgpF2v7T3Wz+upme0zTz7WSzbVWSX5pcvxAAHZCcAFsguQG4CbIF2ALJCbAFkhuAU4AtwBZIToAt4GUAM7sVkdea71lVP71ylzxmdiciLzXnk6p+eeR3c4CZlYJuFkU9quq7R5Fm9iAib4tc36pagHdfIwGU4rohrIgveU8JoFj0Y2VJmiFsiC+PuPdqMTcH1D79a9VfHoch7Ig/nGuvT1wBeEGIEl/qdQfQCyFS/DAArRCixQ8FcBTCNcQPB4BCuJb4EACXINQdennIaZ4cLaeiIZvgWiE7q7wW7jrqQsfg3sNACGHiw1pgCeUChFDxBDDqILTVBqlbABQfOgHCWmBvzk8/BpFDDhLTMuORe4aeA44IOxKLCENjhgFoEdRyDyp0K24IgB4hPfe2wHAH4CHAIwcKwxWAZ+GeuULeBep3+7wfRVf+CxTw3Wf7//RZPP2Pkdy/xtBd92xxrlPgbOKQeggAoTRzDB0w8+oi2ugAhNLMMXTAzKuLaKMDEEozx9ABM68uoo0OQCjNHEMHzLy6iLYfr9PyQV7JesMAAAAASUVORK5CYII=")
        no-repeat center center rgba(#fff, 0.15);
      background-size: ptrd(64);
    }
    //>> 内容区域
    &-card {
      position: fixed;
      z-index: 10;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: ptrd(30) ptrd(32);
      font-size: ptrd(28);
      line-height: ptrd(40);
      text-align: center;
      background: rgba(#000, 0.9);
      border-radius: ptrd(16);
      color: #fff;
      max-width: ptrd(600);
      min-width: ptrd(200);
      box-sizing: border-box;
    }
    //>>> 文字层
    &-text {
      padding: ptrd(6) 0 ptrd(10) 0;
      line-height: ptrd(40);
    }
  }
  //>> 内容区域
  &-card {
    position: fixed;
    z-index: 11;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: ptrd(30) ptrd(32);
    font-size: ptrd(28);
    line-height: ptrd(40);
    text-align: center;
    background: rgba(#000, 0.9);
    border-radius: ptrd(16);
    color: #fff;
    max-width: ptrd(600);
    min-width: ptrd(200);
    box-sizing: border-box;
  }
  //>>> 文字层
  &-text {
    padding: ptrd(6) 0 ptrd(10) 0;
    line-height: ptrd(40);
  }
  &-bg {
    position: fixed;
    z-index: 10;
    top: 50%;
    left: 50%;
    width: 1000%;
    height: 1000%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
}
</style>